exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".update-button[data-v-e46c392a] {\n  background: none;\n  border: none;\n  color: #3498DB;\n  font-size: 16px;\n  cursor: pointer;\n  border-bottom: dashed 1px rgba(52, 152, 219, 0.2);\n  text-decoration: none;\n  padding: 0;\n}\n.update-button[data-v-e46c392a]:hover {\n    color: #e74c3c;\n    border-color: rgba(231, 76, 60, 0.2);\n}\n.demo[data-v-e46c392a] {\n  color: #e74c3c;\n  display: inline-block;\n  font-size: 16px;\n}\n.success[data-v-e46c392a] {\n  color: #27ae60;\n  display: inline-block;\n  font-size: 16px;\n}\n", ""]);

// exports
